<template>
  <div
      v-loading="loading"
      class="order-refund-summary flex flex-auto flex-col">
    <div class="title">
      Refund has been created.
    </div>

    <div class="description">
      The refund has been processed successfully.
    </div>

    <div style="margin-top: 24px">
      <div class="section-header">
        <div class="flex-1">
          Refund Summary
        </div>
      </div>
    </div>

    <div class="refund-details">
      <el-card shadow="never">
        <div class="flex flex-col">
          <div class="summary-header">
            Items
          </div>
          <br>
          <ItemRefundSummaryList
              :items-to-refund="itemsToRefund"
              :refund-shipping="refundShipping"
              :shipping-total="shippingTotal" />
          <el-divider />
          <div class="flex flex-col">
            <div class="summary-header">
              Customer info
            </div>
            <br>
          </div>
          <div class="flex flex-col">
            <div class="flex flex-row">
              <div class="flex-1">
                Name
              </div>
              <div>{{ customer.customer_name }}</div>
            </div>
            <div class="flex flex-row">
              <div class="flex-1">
                Phone Number
              </div>
              <div>{{ customer.customer_phone }}</div>
            </div>
            <div class="flex flex-row">
              <div class="flex-1">
                Email
              </div>
              <div>{{ customer.customer_email }}</div>
            </div>
          </div>

          <el-divider />

          <div class="flex flex-col">
            <div class="summary-header">
              Payments
            </div>
            <br>
          </div>
          <div class="flex flex-col">
            <div class="flex flex-row">
              <div class="flex-1">
                Total Refunded Amount
              </div>
              <div>
                {{ formattedAmount(totalRefundAmount, refundCurrency) }}
              </div>
            </div>
            <div class="flex flex-row">
              <div class="flex-1">
                Currency
              </div>
              <div>{{ refundCurrency }}</div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import numeral from "numeral";
import ItemRefundSummaryList from "./ItemRefundSummaryList.vue";
import { CURRENCY_SYMBOLS } from "@/constants";

export default {
  name: "RefundSummary",
  components: { ItemRefundSummaryList },
  props: {
    customer: {
      type: Object,
      required: true,
      default() {
        return {
          customer_email: "",
          customer_name: "",
          customer_phone: "",
        };
      },
    },
    refundCurrency: {
      type: String,
      default: "USD",
    },
    itemsToRefund: {
      type: Array,
      required: true,
    },
    shippingTotal: {
      type: Number,
      default: 0,
    },
    refundShipping: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    totalRefundAmount() {
      const shippingRefund = this.refundShipping ? this.shippingTotal : 0;
      const totalRefundFromItems = this.itemsToRefund.reduce(
        (total, item) => total + item.refundAmount,
        0
      );

      return totalRefundFromItems + shippingRefund;
    },
  },
  methods: {
    formattedAmount(amount, currency) {
      var neg = false;
      if (amount < 0) {
        neg = true;
        amount = -amount;
      }

      amount = numeral(amount).format(`0,0.00`);
      return `${neg ? "– " : ""}${
        CURRENCY_SYMBOLS[currency || "USD"]
      }${amount}`;
    },
  },
};
</script>

<style>
.order-refund-summary {
  gap: 8px;

  .title {
    height: 36px;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .description {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .section-header {
    height: 24px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #6e6e6e;
    flex: none;
    flex-grow: 1;
  }

  .refund-details {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #424242;

    .summary-header {
      height: 24px;
      font-family: "Equip";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      display: flex;
      align-items: flex-end;
      color: #424242;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
    }
  }
}
</style>
